<script setup lang="ts">
import type { Hub } from '@/data/Hubs/types'
import { useHubClient } from '@/data/Hubs/useHubClient'
import EditHubDialog from '@/modules/Workspaces/KnowledgeHub/Hubs/EditHubDialog.vue'
import { useWorkspaceContext } from '@/modules/Workspaces/useWorkspaceContext'
import IconButton from '@/uiKit/IconButton.vue'
import Menu from '@/uiKit/Menu'
import { ref } from 'vue'

defineProps<{ hub: Hub }>()

const { workspaceId } = useWorkspaceContext()
const hubClient = useHubClient({ workspaceId })
const { mutate: remove } = hubClient.deleteMutation()
const showEditDialog = ref(false)
</script>

<template>
  <Menu.Root
    v-slot="{ getTriggerProps }"
    :positioning="{ placement: 'bottom-end', offset: { mainAxis: 4 } }"
    close-on-select
  >
    <IconButton
      v-bind="{ ...getTriggerProps() }"
      icon="more-dots"
      size="xl"
      rounded
      variant="transparent"
      :aria-label="`${hub.name} additional actions`"
      @click.stop.prevent
    />

    <Menu.Content class="min-w-40">
      <!-- Edit -->
      <Menu.Item
        icon="edit"
        label="Edit"
        @click.stop="showEditDialog = true"
      />

      <Menu.Divider />

      <!-- Delete -->
      <Menu.Item
        critical
        icon="trash"
        label="Delete"
        @click.stop="remove(hub.id)"
      />
    </Menu.Content>
  </Menu.Root>

  <EditHubDialog
    v-model="showEditDialog"
    :hub="hub"
  />
</template>
